const stripHtml = (value = "") =>
  String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

const getFaqName = (item) => item?.question || item?.title || item?.name || "";
const getFaqText = (item) => item?.answer || item?.content || item?.text || "";

const buildFaqPageSchema = (faqs) => {
  const mainEntity = (Array.isArray(faqs) ? faqs : [])
    .map((item) => ({
      name: stripHtml(getFaqName(item)),
      text: stripHtml(getFaqText(item))
    }))
    .filter((item) => item.name && item.text)
    .map((item) => ({
      "@type": "Question",
      name: item.name,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.text
      }
    }));

  if (!mainEntity.length) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity
  };
};

export default buildFaqPageSchema;
